import { call, put, takeEvery } from 'redux-saga/effects';
import { 
  deleteChatSessionRequest, 
  deleteChatSessionSuccess, 
  deleteChatSessionFailure 
} from "../slice/deleteChatSessionSlice";
import { deleteChatSessionApi } from '../../api/apiService';

// Worker saga
export function* handleDeleteChatSession(action: { payload: { chatSessionId: number|string } }): Generator<any, void, any> {
  try {
    const response = yield call(deleteChatSessionApi, action.payload.chatSessionId);

    if (response && response.data) {
      yield put(deleteChatSessionSuccess(response.data));
    } else {
      yield put(deleteChatSessionFailure('Unexpected response from server'));
    }
  } catch (err: any) {
    const safeError = err instanceof Error ? err : new Error(String(err));
    console.error("Delete ChatSession Error:", safeError.stack);
    yield put(deleteChatSessionFailure(safeError.message || 'An unknown error occurred.'));
  }
}

// Watcher saga
export function* deleteChatSessionSaga() {
  yield takeEvery(deleteChatSessionRequest, handleDeleteChatSession);
}
